import { scatterButtons, resetToInitialPosition } from "../helpers-board.js";
import { isMobileDevice } from "../utils.js";
/*
 * Apply the very-light theme to the board;
 * */
function veryLight({ event, board, buttons, registerCleanup, initialPositions }) {
  scatterButtons({ board, buttons });
  board.style = "";
  board.classList.add("very-light");
  event.target.blur();
  setTimeout(() => event.target.blur(), 0);

  if (isMobileDevice()) {
    // ball.style.backgroundColor = "red";
    let lastButtonIndex = null;
    window.addEventListener("deviceorientation", handleOrientation);
  }

  registerCleanup(cleanup);

  function cleanup() {
    board.classList.remove("very-light");
    if (isMobileDevice()) { window.removeEventListener("deviceorientation", handleOrientation) };
    resetToInitialPosition({ board, buttons, initialPositions });
  }

  function handleOrientation(orientEvent) {
    // Back to front rotation value (Y)
    let beta = orientEvent.beta; //[-180, 180)

    // Side to side rotation value (X)
    let gamma = orientEvent.gamma; // [-90, 90) --> [0, 180)

    // Make gamma easier to work with by making the scale 0 to 180
    gamma += 90;

    if (beta < 0) { beta = 0 };
    if (beta > 90) { beta = 90 };

    const ROWS = 6;
    const COLS = 4;
    const ROW_MIN = 0;
    const ROW_MAX = 90;
    const ROW_BIN_WIDTH = (ROW_MAX - ROW_MIN) / ROWS;
    const COL_MIN = 0;
    const COL_MAX = 180;
    const COL_BIN_WIDTH = (COL_MAX - COL_MIN) / COLS;

    // ROW = FLOOR( (BETA - MIN) / ROWS)
    let row_number = Math.floor((beta - ROW_MIN) / ROW_BIN_WIDTH);
    let colNumber = Math.floor((gamma - COL_MIN) / COL_BIN_WIDTH);
    let buttonIndex = Math.min((row_number * COLS + colNumber + 1), 24);
    let lastButtonIndex = 1;
    if (lastButtonIndex && lastButtonIndex !== buttonIndex) {
      document.getElementById(`btn${lastButtonIndex}`).classList.remove("very-light--focused");;
    }

    if (buttonIndex || buttonIndex === 0) {
      let targetButton = document.getElementById(`btn${buttonIndex}`);
      targetButton.focus();
      targetButton.classList.add("very-light--focused");
      lastButtonIndex = buttonIndex;
    }
  }
}


export default veryLight;
